import React from 'react';
import { WhatsAppIcon } from '../Icons';
import { GoogleRatingBadge } from '../Resenas/Resenas';
import { waLink, promesaDeRespuesta } from '../../utils/whatsapp';
import './Hero.css';

/* Mensaje pre-escrito del botón de portada: llega redactado al chat para que
   la persona sólo apriete enviar, y nos dice de dónde vino el contacto. */
const MSG_HERO = 'Hola, los encontré en su página web y quiero agendar una consulta. ¿Qué horas tienen disponibles?';

const Hero: React.FC = () => (
  <section id="hero">
    <video
      className="hero-bg-video"
      src={`${process.env.PUBLIC_URL}/hero.mp4`}
      autoPlay
      muted
      loop
      playsInline
    />
    <div className="hero-overlay" />
    <div className="hero-lines" />
    <div className="hero-content">
      <h1 className="hero-title">
        Abogadas en Concepción
        <span className="hero-title-lema">Defensa legal con compromiso, cercanía y excelencia.</span>
      </h1>
      <div className="hero-ctas">
        <a
          href={waLink(MSG_HERO)}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-whatsapp btn-whatsapp--hero"
        >
          <WhatsAppIcon size={18} /> Agenda por WhatsApp
        </a>
        <div className="hero-respuesta">{promesaDeRespuesta()} · Primera consulta gratis</div>
        {/* El formulario persigue el mismo objetivo que el botón verde, así que
            baja a enlace de texto: sigue disponible para quien lo prefiera, sin
            obligar a elegir entre dos botones que dicen lo mismo. La consulta de
            estado sale de la portada porque es para clientes que ya contrataron;
            vive en el menú, en "Soy cliente". */}
        <a href="#agendar" className="hero-link-form">¿Prefiere dejar sus datos?</a>
      </div>
      <GoogleRatingBadge className="rating-badge--hero hero-rating" />
    </div>
  </section>
);

export default Hero;
